import React from 'react'

function Discoverbutton() {
  return (
    
    <button className="text-[15px] text-black bg-white p-3 rounded-full w-[230px] tracking-wider uppercase">
    discover now
  </button>
  )
}

export default Discoverbutton